import './App.scss'
import 'react-select/dist/react-select.css'

import React, { Component } from 'react'
import AppEnvironmentBanner from 'common/views/components/AppEnvironmentBanner'

class App extends Component {
  render() {
    return (
      <div className="App">
        <AppEnvironmentBanner {...this.props} />
        { this.props.children }
      </div>
    )
  }
}

export default App
